import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { FlexLayoutModule } from "@angular/flex-layout";

import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSelectModule } from "@angular/material/select";

import { CurrentAccountsRoutingModule } from "./current-accounts-routing.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";
import { CategoriesModule } from "src/app/shared/modules/categories/categories.module";
import { PropertiesModule } from "src/app/shared/modules/properties/properties.module";
import { DateTimeModule } from "src/app/shared/modules/date-time/date-time.module";

import { CurrentAccountsListComponent } from "./current-accounts-list/current-accounts-list.component";
import { CurrentAccountsDetailsComponent } from "./current-accounts-detail/current-accounts-detail.component";
import { CurrentAccountMovements } from "./current-account-movements/current-account-movements.component";
import { KpiModule } from "src/app/shared/modules/kpi/kpi.module";
import { CurrentAccountsByPartyList } from "./current-accounts-by-party-list/current-accounts-by-party-list.component";

@NgModule({
  imports: [
    CommonModule,
    CurrentAccountsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CustomTableModule,
    TopCardMaterialModule,
    MatProgressBarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    DateTimeModule,
    FlexLayoutModule,
    CategoriesModule,
    PropertiesModule,
    KpiModule,
  ],
  declarations: [
    CurrentAccountsListComponent,
    CurrentAccountsDetailsComponent,
    CurrentAccountMovements,
    CurrentAccountsByPartyList
  ],
  exports: [
    CurrentAccountMovements,
    CurrentAccountsByPartyList
  ]
})
export class CurrentAccountsModule {}
